/**
 * ahvr-sdk
 * sdk地址：http://npm.corpautohome.com/package/@auto/ahvr-sdk
 * 智能展厅 VR 内饰带看定制版
 * http://wiki.corpautohome.com/pages/viewpage.action?pageId=206243578
 *
 */
import { userActionInterceptor, generateIdDecorator } from '../socketIO/user.action.interceptor';

import { VRProxy } from '@auto/ahvr-sdk';
import config from '@/config';
const vrProxyMap = {
  'viewChange': 'updateView',
  'sceneChange': 'switchScene'
};
const elementId = 'car-360-interior';

@generateIdDecorator(function () {
  return 'VRProxyService_' + this.specId;
})
class VRProxyService {
  constructor (specId) {
    this.specId = specId;
    this.proxy = new VRProxy({
      container: document.getElementById(elementId),
      url: config.dealerPano + specId
    });
    this.ready();
  }
  ready () {
    // VR 页面加载并初始化完毕，可以响应所有支持的命令
    this.proxy.ready(function (error, result) {
      if (error) {
        console.log('vr ready error', result);
        return;
      }
      console.log('vr ready');
    });
  }

  /**
   * 监听来自 VR 页面的事件。
   * @param {*} eventName 事件名称
   */
  listen (eventName) {
    this.proxy.on(eventName, (result) => {
      this.proxyCall(eventName, result);
    });
  }
  @userActionInterceptor({ methodName: 'call' })
  proxyCall (eventName, result) {
    console.log('result:', eventName, result);
  }
  /**
   * 调用 VR 页面提供的具体命令。
   * @param {*} eventName 命令名称
   * @param {*} params 命令参数
   */
  call (eventName, params) {
    this.proxy.call(vrProxyMap[eventName], params).then((data) => {
      console.log('data:', data);
    });
  }
  // 销毁事件，仅把创建的 VR iframe 移除并中断与 VR 的通信。new 出来的对象属性仍会存在。
  destroy () {
    this.proxy.destroy();
  }
}

export default VRProxyService;
